import React from 'react';
import { AirtableDataConsumer, AirtableContextData } from '../core/AirtableDataProvider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

interface Props { }

export default class SkillHighlights extends React.Component<Props> {

  render()
  {
    return (
      <AirtableDataConsumer>
        { data => data && this._render(data) }
      </AirtableDataConsumer>
    );
  }

  _render(data: AirtableContextData)
  {
    const records = data.pageParameters.getArray('SkillHighlight');
    return (
      <div className="flex flex-row justify-center">
        <div className="wfull flex-l flex-row ph3 mv5-ns">

          { records.map(r =>
            <section key={ r.Value } className="flex flex-column pv3 ph2 ph3-ns flex-1">
              <p className="tc theme--primary-color"><FontAwesomeIcon icon={ faCheck } /></p>
              <h3 className="ttu tc mh0">{ r.Value }</h3>
              <p className="lh-copy">{ r.Content }</p>
            </section>
          ) }

        </div>
      </div>
    );
  }

}